import styled from 'styled-components'
import {landGreen} from '@modifi/colors'

const iconPathLength = 20.461454391479492

export const GreenCycle = styled.div<{mounted?: boolean}>`
  width: 40px;
  height: 40px;

  border-radius: 100%;
  background: ${landGreen};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    > path {
      stroke-dasharray: ${iconPathLength};
      stroke-dashoffset: ${({mounted}): number => (mounted ? 0 : iconPathLength)};
      transition: stroke-dashoffset 0.1s 0.1s ease;
    }
  }
`
